import { createStructuredSelector } from "reselect";
import {
	INDEX_PAYMENT_REPORT_REPORT,
	INDEX_PAYMENT_REPORT_REPORT_SUCCESS,
    INDEX_PAYMENT_REPORT_REPORT_ERROR,
    INDEX_PAYMENT_REPORT_SEARCH_SET,
    INDEX_PAYMENT_REPORT_SEARCH_CHANGE,
    INDEX_PAYMENT_REPORT_TAB_SET,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS,
    INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR,
    INDEX_PAYMENT_REPORT_DESTINATION,
    INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS,
    INDEX_PAYMENT_REPORT_DESTINATION_ERROR,
} from "../../actions";

export const NAME = 'idxPaymentReport';

export const IndexPaymentReportReport = (data) => ({
    type: INDEX_PAYMENT_REPORT_REPORT,
    payload: data
});

export const IndexPaymentReportReportSuccess = (data) => ({
    type: INDEX_PAYMENT_REPORT_REPORT_SUCCESS,
    payload: data
});

export const IndexPaymentReportReportError = (error) => ({
    type: INDEX_PAYMENT_REPORT_REPORT_ERROR,
    payload: error
});

export const IndexPaymentReportSearchSet = (data) => ({
    type: INDEX_PAYMENT_REPORT_SEARCH_SET,
    payload: data
});

export const IndexPaymentReportSearchChange = (data) => ({
    type: INDEX_PAYMENT_REPORT_SEARCH_CHANGE,
    payload: data
});

export const IndexPaymentReportTabSet = (data) => ({
    type: INDEX_PAYMENT_REPORT_TAB_SET,
    payload: data
});

export const IndexPaymentReportRegularizationIGSS = (data) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS,
    payload: data
});

export const IndexPaymentReportRegularizationIGSSSuccess = (data) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_SUCCESS,
    payload: data
});

export const IndexPaymentReportRegularizationIGSSError = (error) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_ERROR,
    payload: error
});

export const IndexPaymentReportRegularizationIGSSPDF = (data) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF,
    payload: data
});

export const IndexPaymentReportRegularizationIGSSPDFSuccess = (data) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_SUCCESS,
    payload: data
});

export const IndexPaymentReportRegularizationIGSSPDFError = (error) => ({
    type: INDEX_PAYMENT_REPORT_REGULARIZATION_IGSS_PDF_ERROR,
    payload: error
});

export const IndexPaymentReportDestination = (data) => ({
    type: INDEX_PAYMENT_REPORT_DESTINATION,
    payload: data
});

export const IndexPaymentReportDestinationSuccess = (data) => ({
    type: INDEX_PAYMENT_REPORT_DESTINATION_SUCCESS,
    payload: data
});

export const IndexPaymentReportDestinationError = (error) => ({
    type: INDEX_PAYMENT_REPORT_DESTINATION_ERROR,
    payload: error
});

const idxPaymentReport = (state) => state[NAME];

export const IdxPaymentReportSelector = createStructuredSelector({
    idxPaymentReport
})